import { Flex, Tag } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

interface Props {
  type: string;
  size?: "sm" | "md" | "lg";
  sectionName?: string;
}

export const DataFieldTypeTag = ({ type, sectionName, size }: Props) => {
  const { t } = useTranslation();
  const getEventTagMeta = (
    type: string
  ): {
    color: string;
    text: string;
  } => {
    switch (type) {
      case "Commercial":
        return {
          color: "blue",
          text: t("Commercial"),
        };
      case "Date":
        return {
          color: "purple",
          text: t("Date"),
        };
      case "Financial":
        return {
          color: "green",
          text: t("Financial"),
        };
      case "Other":
        return {
          color: "gray",
          text: t("Other"),
        };
      case "TermsAndConditions":
        return {
          color: "red",
          text: t("Terms & Conditions"),
        };
      default:
        return {
          color: "teal",
          text: type,
        };
    }
  };

  const tagMeta = getEventTagMeta(type);

  return (
    <Flex flexWrap="wrap" justifyContent="center" alignItems="center" gap="1">
      {sectionName && (
        <Tag variant="outline" colorScheme="teal" size={size} textAlign="center">
          {sectionName}
        </Tag>
      )}
      <Tag colorScheme={tagMeta.color} size={size} overflow="hidden" textAlign="center" py="1.5">
        {tagMeta.text}
      </Tag>
    </Flex>
  );
};
